import { Flex } from "antd";
import classNames from "classnames";
import { ReactNode } from "react";
import styles from "./styles.module.scss";

export interface TableTitleLayoutProps {
  filterComponent?: ReactNode;
  total?: number;
  totalText?: string;
  className?: string;
  controlsClassName?: string;
  resultsClassName?: string;
}

export function TableTitleLayout({
  filterComponent,
  total,
  totalText,
  className,
  controlsClassName,
  resultsClassName,
}: TableTitleLayoutProps) {
  const showResults = total !== undefined || totalText !== undefined;

  return (
    <div className={classNames(styles.container, className)}>
      {filterComponent && (
        <div className={classNames(styles.controlsBar, controlsClassName)}>
          {filterComponent}
        </div>
      )}
      {showResults && (
        <Flex
          justify="space-between"
          align="center"
          className={classNames(styles.resultsBar, resultsClassName)}
          style={{ borderTop: filterComponent ? "1px solid #e3e8ee" : "none"}}
        >
          <span className={styles.tableTitle}>
            {totalText ?? `${total} results found`}
          </span>
        </Flex>
      )}
    </div>
  );
}
